let audio: HTMLAudioElement | null = null;
let unlocked = false;

export const Alert = {
    init() {
        if (audio) return;

        audio = new Audio(process.env.PUBLIC_URL + '/sounds/alert-01.wav');
        audio.preload = 'auto';
    },

    unlock() {
        if (!audio || unlocked) return;

        audio.volume = 0;

        audio
            .play()
            .then(() => {
                audio!.pause();
                audio!.currentTime = 0;
                audio!.volume = 1;
                unlocked = true;
            })
            .catch(() => {});
    },

    playSound() {
        if (!audio || !unlocked) return;

        audio.currentTime = 0;

        audio.play();
    },
};
